/** @jsx jsx */
import { jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import isEmpty from 'lodash/isEmpty';
import defaultsDeep from 'lodash/defaultsDeep';
import get from 'lodash/get';
import { SafePureComponent } from '../../../../utils/SafePureComponent';
import PriceGenerator from '../../../ui/PriceGenerator';
import { defaultData } from '../data';
import { Row, Column } from '../../../../styles/Grid';
import * as styles from './index.styles';

const renderSolutions = solutions =>
  solutions.map((solution, index) => (
    <div key={index} css={styles.solutionsContainer}>
      <h2 css={styles.solutionLabel}>
        {get(solution, 'SolutionName.value', '')}
      </h2>
      <span css={styles.solutionPrice}>
        <PriceGenerator price={solution.SolutionPrice} />
      </span>
    </div>
  ));

class Solutions extends SafePureComponent {
  safeRender() {
    const { props } = this;
    const { t } = props;
    const fields = defaultsDeep(props.fields, defaultData);
    const { SolutionPrices, LocationPricesTitle } = fields;

    return (
      <Row>
        <Column css={styles.container} cols={{ md: [5, 8] }}>
          <h2 css={styles.headline}>
            {LocationPricesTitle.value || t('LocationPricesTitle')}
          </h2>
          {!isEmpty(SolutionPrices) && renderSolutions(SolutionPrices)}
        </Column>
      </Row>
    );
  }
}

Solutions.displayName = 'LocationHeader/Solutions';

Solutions.defaultProps = { fields: defaultData, t: key => key };

Solutions.propTypes = {
  fields: PropTypes.shape({
    SolutionPrices: PropTypes.arrayOf(
      PropTypes.shape({
        SolutionName: PropTypes.shape({
          value: PropTypes.string,
        }),
        SolutionPrice: PropTypes.object,
      }),
    ),
  }),
};

export default withNamespaces()(Solutions);
